export default {
	messages: {
		de: {
			name: 'Name',
			actions: {
				logout: 'Abmelden',
				save: 'Speichern',
				archive: 'Archivieren',
				cancel: 'Abbrechen',
				close: 'Schließen',
				yes: 'Ja',
				no: 'Nein',
			},
		},
		en: {
			name: 'Name',
			actions: {
				logout: 'Logout',
				save: 'Save',
				archive: 'Archive',
				cancel: 'Cancel',
				close: 'Close',
				yes: 'Yes',
				no: 'No',
			},
		},
	},
};
